import { AutogenLayoutFactoringCompany } from "./autogen/AutogenLayoutFactoringCompany";
import {
    DataSourceAction, DataSourceExecutionEvent, DropdownSelectionEvent, LookupModelSelectionEvent, Snackbar, TableRow
} from "@mcleod/components";
import { ModelRow, ModelSearchResult } from "@mcleod/core";
import { ModelFactoringCompanyLookup } from "./models/ModelFactoringCompanyLookup";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "factoring_company",
    screenName: "Factoring Company",
    navigateToUrl: "lme/settlement/FactoringCompany?mode=update&key="
};

export class FactoringCompany extends AutogenLayoutFactoringCompany {
    onLoad(): void | Promise<void> {
        this.layoutTableComment.displayCopyOrderFields = false
        DuplicateId.configureIdTextbox(this.textboxId, DUPLICATE_VALIDATION_PROPS);
        this.layoutTableDirectDeposit.usePercentSetup();
        this.mainDataSource.doBeforeDataSourcePost = async () => {
            if (!this.validateDirectDeposit()) {
                return false;
            }
            if (!(await this.validateExternalXref())) {
                Snackbar.showWarningSnackbar(this.textboxExternalXref.validationWarning);
                return false;
            }
        }
        this.textboxExternalXref.addBlurListener(() => {
            this.validateExternalXref();
        });
        this.layoutTableContact.setCarrierContactColumnsVisible(true);
        this.mainDataSource.addAfterExecutionListener((event: DataSourceExecutionEvent) => {
            if (event.getAction() === DataSourceAction.SEARCH) {
                this.setDirectDepositVisibility();
            }
        });
        this.textboxPaymentMethod.addAfterDropdownSelectionListener((event: DropdownSelectionEvent) => {
            if (event.hasSelection()) {
                this.setDirectDepositVisibility();
            }
        });
    }

    setDirectDepositVisibility(): void {
        this.tabDirectDeposit.visible = this.activeRow.get("payment_method") === "D";
    }

    validateDirectDeposit(): boolean {
        if (this.layoutTableDirectDeposit.tableDirectDeposit.rows.filter((row: TableRow) => row.data.getBoolean("acct_activated", false)).length > 1) {
            Snackbar.showWarningSnackbar("Only one direct deposit account can be active at a time.", { targetPanel: this });
            return false;
        }
        if (this.layoutTableDirectDeposit.tableDirectDeposit.rows.filter((row: TableRow) => row.data.getBoolean("acct_activated", false)).length === 0 && this.layoutTableDirectDeposit.tableDirectDeposit.rows.length > 0) {
            Snackbar.showWarningSnackbar("At least one direct deposit account must be active.", { targetPanel: this });
            return false;
        }
        // if no rows exist, then fail
        if (this.layoutTableDirectDeposit.tableDirectDeposit.rows.length === 0 && this.activeRow.get("payment_method") === "D") {
            Snackbar.showWarningSnackbar("An active direct deposit distribution record must be entered when payment method is set to 'Direct Deposit'", { targetPanel: this });
            return false;
        }
        return true;
    }

    async validateExternalXref(): Promise<boolean> {
        const externalXref = this.textboxExternalXref.getDataValue();
        let isValid = true;
        if (externalXref) {
            await new ModelFactoringCompanyLookup().search({ external_xref: externalXref }).then((response: ModelSearchResult) => {
                const existingExternalRefRow: ModelRow = response.modelRows?.find((row: ModelRow) => row.get("external_xref") === externalXref && row.get("id") !== this.activeRow.get("id"));
                if (existingExternalRefRow) {
                    this.textboxExternalXref.validationWarning = "This External ID is already in use in factoring company " + existingExternalRefRow.get("name") + ".";
                    isValid = false;
                }
            });
        }
        return isValid;
    }

    textboxCityOnLookupModelSelection(event: LookupModelSelectionEvent) {
        if (event.hasSelection()) {
            this.activeRow.setValueAndLookupModelData("state", event.selection.get("state_id"), { id: event.selection.get("state_id") });
            this.activeRow.set("zip_code", event.selection.get("zip_code"));
        }
    }
}
